var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useState } from 'react';
import { useLanguage } from '@base/LanguageProvider';
import { ColumnMetaDataContext, HandleMissingTags, TagType, } from '@common/api';
import FSButton from '@components/FSButton';
import { CheckBox } from '@shared/input/CheckBox';
import SelectInput from '@shared/input/SelectInput';
import { useTagContext } from '@data/tag/tagContext';
import { useUpdateImportJob } from '@data/importJob/importJobActions';
import Tags from '@shared/tags/Tags';
import Modal from '@shared/modal/Modal';
import Manager from '@shared/modal/Manager';
import ModalHeader from '@shared/modal/ModalHeader';
import { ModalBody, ModalFooterStyled } from '@styled/Modal';
import { globalLoadingWrapped } from './util';
export default function ImportConfigureModal(_a) {
    var _b;
    var _this = this;
    var _c;
    var importJob = _a.importJob;
    var L = useLanguage().L;
    var tagData = useTagContext().tagData;
    var updateImportJob = useUpdateImportJob();
    var _d = __read(useState(importJob.metadata.handleMissingTags), 2), handleMissingTags = _d[0], setHandleMissingTags = _d[1];
    var _e = __read(useState(importJob.metadata.importZeros), 2), importZeros = _e[0], setImportZeros = _e[1];
    var _f = __read(useState(importJob.metadata.overwriteCells), 2), overwriteCells = _f[0], setOverwriteCells = _f[1];
    var _g = __read(useState([]), 2), valueTags = _g[0], setValueTags = _g[1];
    var addValueTag = function (tagId) {
        var newConnectedTags = __spreadArray([], __read(valueTags), false);
        var tag = tagData.tagById[tagId];
        if (tag !== undefined) {
            newConnectedTags.push(tag);
        }
        setValueTags(newConnectedTags);
    };
    var removeValueTag = function (tagId) {
        var newConnectedTags = __spreadArray([], __read(valueTags), false);
        newConnectedTags.filter(function (t) { return t.id !== tagId; });
        setValueTags(newConnectedTags);
    };
    var save = function () { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, globalLoadingWrapped(function () { return __awaiter(_this, void 0, void 0, function () {
                        var columnMetasCopy, valueTagsIds, columnMetasCopy_1, columnMetasCopy_1_1, columnMetaCopy;
                        var e_1, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    columnMetasCopy = importJob.metadata.columnMetas.map(function (cm) { return (__assign({}, cm)); });
                                    if (valueTags.length > 0) {
                                        valueTagsIds = valueTags.map(function (t) { return t.id; });
                                        try {
                                            for (columnMetasCopy_1 = __values(columnMetasCopy), columnMetasCopy_1_1 = columnMetasCopy_1.next(); !columnMetasCopy_1_1.done; columnMetasCopy_1_1 = columnMetasCopy_1.next()) {
                                                columnMetaCopy = columnMetasCopy_1_1.value;
                                                if (columnMetaCopy.dataContext === ColumnMetaDataContext.TIMEPOINT ||
                                                    columnMetaCopy.dataContext === ColumnMetaDataContext.VALUES) {
                                                    columnMetaCopy.applyTagsIds = valueTagsIds;
                                                }
                                            }
                                        }
                                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                        finally {
                                            try {
                                                if (columnMetasCopy_1_1 && !columnMetasCopy_1_1.done && (_a = columnMetasCopy_1.return)) _a.call(columnMetasCopy_1);
                                            }
                                            finally { if (e_1) throw e_1.error; }
                                        }
                                    }
                                    return [4 /*yield*/, updateImportJob.mutateAsync({
                                            id: importJob.id,
                                            metadata: __assign(__assign({}, importJob.metadata), { handleMissingTags: handleMissingTags, importZeros: importZeros, overwriteCells: overwriteCells, columnMetas: columnMetasCopy }),
                                        })];
                                case 1:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    Manager.closeModal();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleMissingTagsOptions = [
        { label: L('Disallow'), value: HandleMissingTags.DISALLOW },
        { label: L('Skip row'), value: HandleMissingTags.SKIP_ROW },
        // { label: L('Import'), value: HandleMissingTags.IMPORT },
    ];
    var handleMissingTagsDescriptions = (_b = {},
        _b[HandleMissingTags.DISALLOW] = L('Will not allow import as long as there are missing tags.'),
        _b[HandleMissingTags.SKIP_ROW] = L('Will skip rows with missing tags.'),
        _b[HandleMissingTags.IMPORT] = L('Will import rows without missing tags.'),
        _b);
    return (React.createElement(Modal, { width: '900', closeable: false },
        React.createElement(ModalHeader, { title: L('Configure job options') }),
        React.createElement(ModalBody, null,
            React.createElement("div", null,
                React.createElement(SelectInput, { name: "selectHandleMissingTags", label: L('Handle Missing Table Dimensions'), value: handleMissingTags, options: handleMissingTagsOptions, onChange: function (e) {
                        if (typeof e.target.value === 'string') {
                            setHandleMissingTags(e.target.value);
                        }
                        else {
                            setHandleMissingTags(HandleMissingTags.DISALLOW);
                        }
                    }, bottomMargin: true }),
                React.createElement("small", null, (_c = handleMissingTagsDescriptions[handleMissingTags]) !== null && _c !== void 0 ? _c : '')),
            React.createElement("hr", null),
            React.createElement("div", null,
                React.createElement(CheckBox, { checked: importZeros, label: L('Import zeros') + '?', action: function () {
                        setImportZeros(!importZeros);
                    } }),
                React.createElement(CheckBox, { checked: overwriteCells, label: L('Overwrite cells') + '?', action: function () {
                        setOverwriteCells(!overwriteCells);
                    } })),
            React.createElement("hr", null),
            React.createElement("div", null,
                React.createElement("h5", null, L('Apply tags to value columns') + ':'),
                React.createElement(Tags, { tags: valueTags, select: addValueTag, remove: removeValueTag, filterByTypes: [TagType.Account, TagType.Dimension] }))),
        React.createElement(ModalFooterStyled, null,
            React.createElement(FSButton, { title: L('Cancel'), onClick: Manager.closeModal, "$type": "secondary" }),
            React.createElement(FSButton, { title: L('Save'), onClick: save }))));
}
